import {StatusIndicator, StatusIndicatorProps} from "@amzn/awsui-components-react-v3";
import React from "react";

export const getStatusIndicator = (status : string, statusTypeFn: (status: string) => StatusIndicatorProps.Type | null) => {
    let mappedStatus = mapStatus(status, statusTypeFn);
    return (mappedStatus ?
        <StatusIndicator type={mappedStatus.type}>{mappedStatus.label}</StatusIndicator> :
        status || '-')
}

function mapStatus(status: string, statusTypeFn: (status: string) => StatusIndicatorProps.Type | null) {
    const statusType = statusTypeFn(status);
    return statusType ? { label: status, type: statusType } : null;
}